module.exports = __webpack_public_path__ + "static/media/IMG-16.7b24a76b.jpg";